<template>
    <li v-if="isTrialTariff" class="nav-item dropdown d-flex align-items-center mr-2" :class="{ show: showDropdownMenu }" @mouseenter="showDropdownMenu = true" @mouseleave="showDropdownMenu = false">
        <div class="trial-tariff d-flex align-items-center">
            <i class="icon-medal2 trial-tariff-icon mr-2"></i>
            <span class="font-weight-semibold">{{ $t('navbar.first.trialTariff.label') }}</span>
            <router-link :to="{ name: 'IndexTariffsPage', params: { projectUuid: project.uuid } }" class="trial-tariff-button ml-2">
                {{ $t('navbar.first.trialTariff.chooseTariff') }}
            </router-link>
        </div>
        <div class="dropdown-menu trial-tariff-dropdown" :class="{ show: showDropdownMenu }">
            <div class="text-uppercase text-muted font-size-sm font-weight-semibold mb-2">{{ $t('navbar.first.trialTariff.limitsTitle') }}</div>
            <div class="d-flex align-items-center py-1">
                <i class="icon-link trial-tariff-limit-icon mr-2"></i>
                {{ $t('navbar.first.trialTariff.integrationsLimit', { count: project.tariff.integrations_limit }) }}
            </div>
            <div class="d-flex align-items-center py-1">
                <i class="icon-archive trial-tariff-limit-icon mr-2"></i>
                {{ $t('navbar.first.trialTariff.productsLimit', { count: project.tariff.products_limit }) }}
            </div>
        </div>
    </li>
</template>
<script>
import {mapGetters} from "vuex";

export default {
    name: "TrialTariffTab",
    data() {
        return {
            showDropdownMenu: false
        }
    },
    computed: {
        ...mapGetters('route', ['project']),
        isTrialTariff() {
            return Boolean(this.project?.tariff) && this.project.tariff.price === null;
        }
    },
    watch: {
        $route() {
            this.showDropdownMenu = false;
        }
    }
}
</script>
<style scoped>
.trial-tariff {
    padding: 4px 4px 4px 14px;
    color: #fff;
    background: rgba(255, 255, 255, .12);
    border: 1px solid rgba(255, 255, 255, .25);
    border-radius: 100px;
    white-space: nowrap;
}
.trial-tariff-icon {
    color: #FFC107;
}
.trial-tariff-button {
    padding: 4px 14px;
    color: #333;
    font-size: 12px;
    font-weight: 600;
    text-transform: uppercase;
    background: #FFC107;
    border-radius: 100px;
}
.trial-tariff-button:hover {
    color: #333;
    background: #FFB300;
}
.trial-tariff-dropdown {
    top: 100%;
    left: 0;
    right: 0;
    min-width: 0;
    margin-top: 6px;
    padding: 14px 16px;
    border: 0;
    border-radius: 16px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, .2);
}
.trial-tariff-dropdown::before {
    content: '';
    position: absolute;
    top: -6px;
    left: 0;
    right: 0;
    height: 6px;
}
.trial-tariff-limit-icon {
    color: #FF9800;
}
</style>
